/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserDelegation extends models.UserDelegationRequest {
    getFixupPrototypeFunction() { return UserDelegation.fixupPrototype; }

    static newInstance(model: Partial<UserDelegation>): UserDelegation {
        let obj = Object.assign(new UserDelegation(), model);
        UserDelegation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserDelegation>): UserDelegation {
        if (!model) return null;
        return UserDelegation.newInstance(<UserDelegation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserDelegation) {
        if (!obj) return;

        models.UserDelegation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserDelegation): boolean {
        if (models.UserDelegationRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, UserDelegation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
    }

    /**
     * User delegation source account master id
     */
    source_master_account_id: string;

    /**
     * Date and Time of Creation
     */
    created_at: Date;

    /**
     * User that created delegation
     */
    created_by: string;

    /**
     * Date and Time of Last Update
     */
    updated_at: Date;

    /**
     * User that last updated delegation
     */
    updated_by: string;

}
